<template>
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    ref="teacherModal"
  >
    <div class="modal-dialog modal-dialog-centered teacher-info">
      <div class="modal-content">
        <div class="container-fluid">
          <div class="row info-content">
            <div class="col-6 col-lg-4 px-0">
              <img :src="teacherInfo.modalImg" class="w-100" />
            </div>
            <div class="col-6 col-lg-8 px-5">
              <div class="text d-flex flex-column justify-content-center py-5">
                <h3 class="mb-3">{{ teacherInfo.name }}</h3>
                <p>{{ teacherInfo.title }}</p>
                <div class="intro">
                  <p v-for="(text, index) in teacherInfo.intro" :key="index">
                    {{ text }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "bootstrap/js/dist/modal";

export default {
  data() {
    return {
      modal: {},
      teacherInfo: {},
    };
  },
  methods: {
    openTeacherModal(info) {
      this.modal.show();
      this.teacherInfo = info;
    },
    hideTeacherModal() {
      this.modal.hide();
    },
  },
  mounted() {
    this.modal = new Modal(this.$refs.teacherModal);
  },
};
</script>

<style lang="scss">
.teacher-info {
  img {
    height: 440px;
    object-fit: cover;
    border-radius: 1.5rem 0 0 1.5rem;
  }
  .modal-content {
    border-radius: 1.6rem;
  }

  .text {
    max-height: 440px;
    .intro {
      overflow: auto;
    }
  }
}

.modal-dialog {
  width: 800px !important;
  max-width: calc(100% - 20px) !important;
}

@media (max-width: $md) {
  .modal-dialog {
    width: 500px !important;
  }
}
</style>
